
































































































































































































































import { DataHelper } from "@/helpers/DataHelper";
import { FieldInterface, StepPersonalData } from "@/types.d.ts";
import { DocumentType } from "@/constants/form-values";
import { Locale } from "@/constants/locale";
import SubmitButton from "@/components/basic/buttons/SubmitButton.vue";
import CheckBox from "@/components/basic/fields/CheckBox.vue";
import Field from "@/components/basic/fields/Field.vue";
import DateField from "@/components/compositeFields/DateField.vue";
import Select from "@/components/basic/fields/Select.vue";
import Loader from "@/components/basic/Loader.vue";
import Vue from "vue";
import { UtilityHelper } from "@/helpers/UtilityHelper";
import { mapState } from "vuex";
import { SET_PROGRESS } from "@/constants/mutation-types";
import TheCountrySelect from "@/components/basic/fields/TheCountrySelect.vue";
import i18n from "@/i18n";
import { PERSONAL_ID_IGNORE_COUNTRIES } from "@/constants/country-settings";
import { countryToAlpha2 } from "country-to-iso";

export default Vue.extend({
  name: "PersonalData",
  data() {
    return {
      DateFieldNames,
      Locale,
      UtilityHelper,
      months: [] as FieldInterface[],
      formData: {
        firstName: "",
        lastName: "",
        dateOfBirth: "",
        documentExpirationDate: "",
        citizenship: "",
        identificationNumber: "",
        pesel: "",
        noPesel: false,
        documentType: "",
        documentNumber: "",
        noLimitExpiryDate: false,
      } as StepPersonalData,
      isValidateIdentificationField: true,
      documentExpirationDate: "",
      isDateFieldFilled: false,
      isOpenPersonalDataLayer: false,
      isAnimating: false,
      formIsValid: false,
      numericalID: false,
      TRANSLATION_KEY: "steps.PersonalData",
    };
  },

  created() {
    this.setFormData();
  },

  beforeDestroy(): void {
    if (window.localStorage.getItem(KeyWords.PATH)) {
      window.localStorage.removeItem(KeyWords.PATH);
    }

    if (window.localStorage.getItem(KeyWords.IS_RETURNING)) {
      window.localStorage.removeItem(KeyWords.IS_RETURNING);
    }
  },
  async beforeMount(): Promise<void> {
    if (
      window.localStorage.getItem(KeyWords.PATH) &&
      !window.localStorage.getItem(KeyWords.IS_RETURNING) &&
      this.stepName === KeyWords.PERSONAL_DATA_CONFIRM
    ) {
      this.isAnimating = true;

      await UtilityHelper.sleep(1500);

      const waitForFormData = setInterval(() => {
        if (this.formData.firstName.length && this.formData.documentNumber.length) {
          const formHasErrors = this.checkWhetherFormHasErrors() as boolean;

          if (formHasErrors) {
            this.isAnimating = false;
          } else {
            if (this.formData.pesel.length || this.formData.identificationNumber.length) {
              this.isOpenPersonalDataLayer = true;
              this.isAnimating = false;
            } else {
              this.isAnimating = false;
            }
          }

          clearInterval(waitForFormData);
        }
      });
    }
    this.$store.state.showHeader = true;
  },
  mounted(): void {
    if (this.$store.state.timeToFinish >= 7) {
      this.$store.commit(SET_PROGRESS, 7);
    }
    this.isValid();
    setInterval(this.isValid, 100);
    this.isNumericalId();
  },
  methods: {
    isValid() {
      const labels = document.querySelectorAll("form .row:not(.row--is-never-expiration-document) label");
      const customSelects = document.querySelectorAll(".custom-select-wrapper .custom-select");
      const labelsLength = labels.length;
      const selectsLength = customSelects.length;
      let validLabelsLength = 0;
      let validSelectsLength = 0;
      customSelects.forEach(select => {
        if (select.classList.contains("valid")) {
          validSelectsLength++;
        }
      });
      labels.forEach(label => {
        if (label.classList.contains("valid")) {
          validLabelsLength++;
        }
      });

      if (!this.isValidateIdentificationField) {
        validLabelsLength++;
      }

      if (validLabelsLength === labelsLength && validSelectsLength === selectsLength) {
        this.formIsValid = true;
      } else {
        this.formIsValid = false;
      }
    },
    validateDateOfBirth() {
      this.$store.dispatch("validate", {
        name: DateFieldNames.BIRTH,
        value: this.formData.dateOfBirth,
      });
    },
    validateDateOfExpiration() {
      this.$store.dispatch("validate", {
        name: DateFieldNames.EXPIRATION,
        value: this.formData.documentExpirationDate,
      });
    },
    determineGenuineValue(arr: string[]): string {
      let genuineValue = "" as string;

      for (let i = 0, length = arr.length; i < length; i++) {
        if (arr[i].length) {
          genuineValue = arr[i];
        }
      }

      return genuineValue;
    },
    checkWhetherFormHasErrors(): boolean {
      const hardcodedErrorNames = [
        "firstName",
        "lastName",
        "dateOfBirth",
        "citizenship",
        "pesel",
        "identificationNumber",
        "documentType",
        "documentNumber",
        "documentExpirationDate",
      ] as string[];

      let isError = false as boolean;

      hardcodedErrorNames.forEach((errorName: string) => {
        if (this.$store.state.errors.has(errorName)) {
          isError = true;
        }
      });

      return isError;
    },
    loadMonthsTranslations() {
      DataHelper.loadJSON(i18n.locale).then(data => {
        Object.entries(data).forEach(([key, value]) => {
          if (key === "months") {
            // @ts-ignore
            this.months = value;
          }
        });
      });
    },
    isEuropeanCountry: function(): boolean {
      return this.$store.state.config.europeanCountries.includes(this.formData.citizenship);
    },
    showIdentificationNumberField: function(): boolean {
      if (this.formData.citizenship !== null && this.formData.citizenship.length) {
        if (PERSONAL_ID_IGNORE_COUNTRIES.indexOf(this.formData.citizenship) !== -1) return false;
      }
      return true;
    },
    getPersonalIdNumberDescription: function(): any {
      if (!this.showIdentificationNumberField()) return null;
      if (this.formData.citizenship !== null && this.formData.citizenship.length) {
        let citizenshipCode = this.formData.citizenship;
        citizenshipCode = citizenshipCode[0] + "" + citizenshipCode.slice(1).toLowerCase();
        let t = "steps.PersonalData.personalIdNumberDescription" + citizenshipCode;
        return this.$t(t) != t ? this.$t(t) : this.$t("steps.PersonalData.personalIdNumberDescription");
      }
      return null;
    },

    isNumericalId() {
      const numericCountries = "be, bg, cz, dk, ee, gr, hr, lt, lv, pl, pt, ro, se, se, sl, sk";
      this.numericalID = numericCountries.includes(UtilityHelper.getLocale());
    },

    setFormData() {
      if (!Array.isArray(this.clientIdData)) {
        return;
      }
      const documentType = this.getExtractedFieldValue("DocumentType");
      if (this.getExtractedFieldValue("FirstName")) {
        this.formData.firstName = this.getExtractedFieldValue("FirstName");
      }

      if (this.getExtractedFieldValue("LastName")) {
        this.formData.lastName = this.getExtractedFieldValue("LastName");
      }

      if (
        this.$store.state.clientIdData.length !== 0 &&
        this.$store.state.clientIdData[0].IssuingCountryCode.length !== 0
      ) {
        //@ts-ignore
        this.formData.citizenship = countryToAlpha2(this.$store.state.clientIdData[0].IssuingCountryCode);
      }

      const personalNumber = this.getExtractedFieldValue("PersonalNumber");
      const optionalValue2 = this.getExtractedFieldValue("OptionalValue2");

      if (this.formData.citizenship === "PL") {
        this.formData.pesel = personalNumber || optionalValue2 || "";
      } else {
        this.formData.identificationNumber = personalNumber || optionalValue2 || "";
      }

      if (documentType == "National Identification Card") {
        this.formData.documentType = "1";
      } else if (documentType == "Passport") {
        this.formData.documentType = "2";
      } else {
        this.formData.documentType = "3";
      }

      if (this.getExtractedFieldValue("DocumentNumber")) {
        this.formData.documentNumber = this.getExtractedFieldValue("DocumentNumber");
      }

      if (this.getExtractedFieldValue("BirthDate")) {
        this.formData.dateOfBirth = this.getExtractedFieldValue("BirthDate");
      }

      if (this.getExtractedFieldValue("ExpiryDate")) {
        this.formData.documentExpirationDate = this.getExtractedFieldValue("ExpiryDate");
      }

      this.$store.commit("SET_FORM_DATA", this.formData);
    },
    getExtractedFieldValue(fieldName: string): string {
      if (this.clientIdData.length !== 0) {
        for (const data of this.clientIdData) {
          if (!data || !data.ExtractedFields) continue;
          const field = data.ExtractedFields.find((field: any) => field.Name === fieldName);
          if (field) return field.Value;
        }
      }
      return "";
    },
  },
  watch: {
    clientIdData(newVal) {
      if (Array.isArray(newVal) && newVal.length) {
        this.setFormData();
      }
    },
    
    "formData.dateOfBirth"(newValue): void {
      this.$store.dispatch("validate", {
        name: DateFieldNames.BIRTH,
        value: newValue,
      });
    },

    "formData.identificationNumber"(newValue): void {
      if (newValue && newValue.length && this.formData.citizenship !== "PL") {
        this.formData.noPesel = true;

        if (this.formData.pesel.length) {
          this.formData.pesel = "";
        }
      }
    },

    "formData.citizenship"(newValue): void {
      const numericCountries = "be, bg, cz, dk, ee, gr, hr, lt, lv, pl, pt, ro, se, se, si, sk, is, no";
      this.numericalID = numericCountries.includes(this.formData.citizenship.toLowerCase());
      if (newValue && newValue.length && this.formData.citizenship == "GR") {
        this.isValidateIdentificationField = false;
      } else {
        this.isValidateIdentificationField = true;
      }
      if (newValue && newValue.length && this.formData.citizenship != "PL") {
        this.formData.pesel = "";
        this.formData.noPesel = true;
      } else {
        this.formData.noPesel = false;
      }
    },

    "formData.pesel"(newValue): void {
      if (
        newValue &&
        newValue.length &&
        this.formData.identificationNumber.length &&
        this.formData.citizenship === "PL"
      ) {
        this.formData.identificationNumber = "";

        if (this.formData.noPesel) {
          this.formData.noPesel = false;
        }
      }
      if (
        newValue &&
        newValue.length &&
        this.formData.identificationNumber.length &&
        this.formData.citizenship !== "PL"
      ) {
        this.formData.pesel = "";
      }
    },

    "formData.noLimitExpiryDate"(newValue): void {
      if (newValue) {
        this.documentExpirationDate = this.formData.documentExpirationDate;
        this.formData.documentExpirationDate = "";
      } else {
        this.formData.documentExpirationDate = this.documentExpirationDate.replace(/X/gi, "");
      }
    },
  },
  computed: {
    ...mapState({
      citizenship: (state: any): FieldInterface[] => state.config.citizenship,
      isSubheaderVisible: (state: any): boolean => state.isSubheaderVisible,
      stepName: (state: any): string => state.step,
      clientIdData: (state: any): any => state.clientIdData,
    }),
    documentTypes(): FieldInterface[] {
      if (!this.isEuropeanCountry()) {
        return [
          {
            key: DocumentType.ID,
            value: this.$t("steps.PersonalData.documentTypeThree"),
          },
          {
            key: DocumentType.PASSPORT,
            value: this.$t("steps.PersonalData.documentTypeTwo"),
          },

          {
            key: DocumentType.OTHER,
            value: this.$t("steps.PersonalData.documentTypeFour"),
          },
        ] as FieldInterface[];
      } else {
        return [
          {
            key: DocumentType.PASSPORT,
            value: this.$t("steps.PersonalData.documentTypeTwo"),
          },
          {
            key: DocumentType.ID,
            value: this.$t("steps.PersonalData.documentTypeThree"),
          },
          {
            key: DocumentType.OTHER,
            value: this.$t("steps.PersonalData.documentTypeFour"),
          },
        ] as FieldInterface[];
      }
    },
    personalIdNumberDescription(): any {
      return this.getPersonalIdNumberDescription();
    },
  },
  components: {
    CheckBox,
    Field,
    Select,
    SubmitButton,
    DateField,
    Loader,
    TheCountrySelect,
  },
});

enum DateFieldNames {
  BIRTH = "dateOfBirth",
  EXPIRATION = "documentExpirationDate",
}

enum KeyWords {
  PATH = "path",
  IS_RETURNING = "isReturning",
  PERSONAL_DATA_CONFIRM = "personalDataConfirm",
}
